import { cn } from "@/utils/cn";
import { ReactNode } from "react";

interface UnderlinedTextButtonProps {
  className?: string;
  onClick: () => void;
  children?: ReactNode;
  style?: React.CSSProperties;
}

export const UnderlinedTextButton = ({
  className,
  onClick,
  children,
}: UnderlinedTextButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn("text-xs font-light underline", className)}
    >
      {children}
    </button>
  );
};
